import { render, staticRenderFns } from "./formDataList.vue?vue&type=template&id=c1743452&scoped=true"
import script from "./formDataList.vue?vue&type=script&lang=js"
export * from "./formDataList.vue?vue&type=script&lang=js"
import style0 from "./formDataList.vue?vue&type=style&index=0&id=c1743452&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1743452",
  null
  
)

export default component.exports